import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "environment";

import { Cookie } from "ng2-cookies/cookie";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.ENV === 'development') {
      req = req.clone({
        headers: req.headers.set('X-Auth-Token', Cookie.get('SESSION')),
        params: req.params.set('api_key', environment.API_UMBRELLA_KEY)
      });
    }

    return next.handle(req);
  }
}
